import { Component, input } from '@angular/core';

@Component({
  selector: 'dot-matrix-loader',
  template: `
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24" aria-hidden="true">
      <circle class="wave-0" cx="4.94" cy="4.94" r="2.12" />
      <circle class="wave-2" cx="12" cy="4.94" r="2.12" />
      <circle class="wave-0" cx="19.06" cy="4.94" r="2.12" />
      <circle class="wave-4" cx="4.94" cy="12" r="2.12" />
      <circle class="wave-5" cx="12" cy="12" r="2.12" />
      <circle class="wave-4" cx="19.06" cy="12" r="2.12" />
      <circle class="wave-7" cx="4.94" cy="19.06" r="2.12" />
      <circle class="wave-8" cx="12" cy="19.06" r="2.12" />
      <circle class="wave-7" cx="19.06" cy="19.06" r="2.12" />
    </svg>
  `,
  styleUrl: './dot-matrix-loader.scss',
  host: {
    '[class.paused]': 'paused()',
  },
})
export class DotMatrixLoader {
  size = input<string>('20px');
  paused = input(false);
}
